export type SectionProps<T extends (...args: any[]) => any> = Awaited<
  ReturnType<T>
>;

export type Resolved<T = any> = T;

export type Section = any;

export type Block = any;

export type LoadingFallbackProps = {
  height?: number;
};

// Section/loader function context. The framework's own `FnContext` from
// `@decocms/blocks/types` only carries `state`, but our loaders also read
// `device`, `invoke`, and write to `response` (request headers / status).
// We mirror what the runtime actually provides so consumers don't have to
// cast at every call site.
export interface FnContext<TState = unknown> {
  state: TState
  device?: "mobile" | "tablet" | "desktop"
  invoke?: any
  response?: { headers: Headers; status?: number }
}

export type AppContext<TState = unknown> = FnContext<TState>;

export type { MatchContext } from "@decocms/apps-website";

// `defer` is accepted for API parity with deco-cx's asResolved (deferred props)
// but is a runtime no-op here — we just pass the value through.
export function asResolved<T>(value: T, _defer?: boolean): T {
  return value;
}

export function isDeferred(value: unknown): boolean {
  return false;
}

export const context = {
  isDeploy: false,
  platform: "tanstack-start" as const,
  site: "miess",
  siteId: 0,
};

export function redirect(_url: string, _status?: number): never {
  throw new Error("redirect is not supported in TanStack Start -- use router navigation instead");
}
